export const SET_NTV = 'SET_NTV';

export default {
    [SET_NTV]: (state, payload) => (state.noticeToVacate = payload),
};
